import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import Map, { MapRef, Marker } from 'devextreme-react/map';
import TenantContext from '../../contexts/tenantContext';
import { EmergenzeApi, PuntiDiRaccoltaApi, TenantsApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { useScreenSize } from '../../utils/media-query';
import { LoadPanel } from 'devextreme-react';
import { mapConfiguration } from '../../mapConfig';

type Props = {
  //emergenzaId: string
}

export type EmergenzaMapPanelHandle = {}

type marker = {
  /**
   * A URL pointing to the custom icon to be used for the marker.
   */
  iconSrc?: string;
  /**
   * Specifies the marker location.
   */
  location?: any | string | Array<number>;
  /**
   * A callback function performed when the marker is clicked.
   */
  onClick?: Function;
  /**
   * A tooltip to be used for the marker.
   */
  tooltip?: string | {
    /**
     * Specifies whether a tooltip is visible by default or not.
     */
    isShown?: boolean;
    /**
     * Specifies the text or HTML markup displayed in the tooltip.
     */
    text?: string;
  };
}

const CurrentEmergenzaMapPanel: React.ForwardRefRenderFunction<EmergenzaMapPanelHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [defaultCenterMap, setDefaultCenterMap] = useState<string>();
  const [assistitiMarkers, setAssistitiMarkers] = useState<marker[]>([]);
  const [puntiDiRaccoltaMarkers, setPuntiDiRaccoltaMarkers] = useState<marker[]>([]);
  const [meMarker, setMeMarkers] = useState<marker>();
  const [markers, setMarkers] = useState<marker[]>([]);
  const { isXSmall } = useScreenSize();
  const [zoom, setZoom] = useState<number>(14);
  const [loading, setLoading] = React.useState<boolean>(true);
  const mapRef = useRef<MapRef>(null); 
  const refreshTimerInterval = 5000; // 5 seconds

  useEffect(() => {
    (async function () {
      await GetDefaultCenterMap();
      await refreshAssistitiMarkers();
      await refreshPuntiDiRaccoltaMarkers();
      refreshMeMarker();
    })();

  }, [currentTenant, props]);


  async function GetDefaultCenterMap() {
    const api = new TenantsApi(apiConfiguration);

    if (currentTenant) {
      var data = await api.getTenantAnagraficaById({ tenantId: currentTenant.Id });
      setDefaultCenterMap(`${data.comune}, ${data.provincia}, ${data.nazioneId}`);
      setLoading(false);  
    }
  }

  async function refreshAssistitiMarkers() {
    const api = new EmergenzeApi(apiConfiguration);

    if (currentTenant) {
      var data = await api.getCurrentEmergenzaAssistitiByCurrentOperatore({ tenantId: currentTenant.Id });

      var markers = data.map(e => ({
        location: `${e.assistito?.residenzaIndirizzo} ${e.assistito?.residenzaNumeroCivico}, ${e.assistito?.residenzaComune}, ${e.assistito?.residenzaProvincia}, ${e.assistito?.residenzaNazioneId}`,
        tooltip: e.assistito ? { text: `${e.assistito.nome} ${e.assistito.cognome}` } : undefined,
        onClick: () => {
          console.log('clicked');
        }
      }));

      setAssistitiMarkers(markers);
    }
  }

  async function refreshPuntiDiRaccoltaMarkers() {
    const api = new PuntiDiRaccoltaApi(apiConfiguration);

    if (currentTenant) {
      var data = await api.getPuntiDiRaccolta({ tenantId: currentTenant.Id });

      var markers = data.map(e => ({
        location: e.latitudine && e.longitudine ? [e.latitudine, e.longitudine] : `${e.indirizzo} ${e.numeroCivico}, ${e.comune}, ${e.provincia}, ${e.nazioneId}`,
        tooltip: e.nome ? { text: `${e.nome}` } : undefined,
        iconSrc: "/images/location-pin-green.svg"
      }));

      setPuntiDiRaccoltaMarkers(markers);
    }
  }

  const refreshMeMarker = useCallback(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lon = pos.coords.longitude;

        setMeMarkers({
          location: [lat, lon],
          iconSrc: "/images/location-pin-red.svg"
        });
      },
      (err) => {
        console.warn("Posizione non disponibile:", err.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 0
      }
    );
  }, []);

  useEffect(() => {
    refreshMeMarker();

    const intervalId = setInterval(() => {
      refreshMeMarker();
    }, refreshTimerInterval);

    // Cleanup
    return () => clearInterval(intervalId);
  }, [refreshMeMarker]);

  useEffect(() => {
    if (meMarker)
      setMarkers([
        ...assistitiMarkers ?? [],
        ...puntiDiRaccoltaMarkers ?? [],
        meMarker
      ]);
    else
      setMarkers(assistitiMarkers);

  }, [assistitiMarkers, puntiDiRaccoltaMarkers, meMarker]);

  return (
    <React.Fragment>
      {defaultCenterMap && markers &&
        <Map
          ref={mapRef}
          defaultCenter={defaultCenterMap}
          defaultZoom={zoom}
          markerIconSrc="/images/location-pin-blue.svg"
          height={isXSmall ? "calc(100vh - 160px)" : "calc(100vh - 250px)"}
          width="100%"
          provider="azure"
          type="hybrid"
          apiKey={mapConfiguration}
          markers={markers}
          onZoomChange={setZoom}
          autoAdjust={false}
        >
        </Map>
      }
      {!defaultCenterMap && !loading &&
        <div>Indirizzo del comune non definito</div>
      }

      <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: '.dx-card' }}
            visible={loading}
            showIndicator={true}
            shading={false}
            showPane={true}
            hideOnOutsideClick={false}
          />
    </React.Fragment>

  )
}

export default React.forwardRef(CurrentEmergenzaMapPanel);
